import { makeStyles } from '@mui/styles'
import { defaultPalette } from '../../../theme/idsTheme'

export default makeStyles(() => ({
    ButtonSelector: {
        position: 'relative',
        zIndex: 500,
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        background: '#ffffff',
        borderWidth: 2,
        borderColor: defaultPalette.lightGrey.dark,
        borderRadius: 12,
        height: '55px',
        transition: 'none',
        padding: '1rem',
        gap: '1rem',
        '&:hover': {
            borderColor: `${defaultPalette.typography.main} !important`,
        },
        '&.Mui-disabled': {
            borderWidth: 2,
            borderColor: defaultPalette.lightGrey.dark,
            '& svg path': {
                fill: defaultPalette.lightGrey.darker,
            },
        },
    },
    ButtonSelectorLabel: {
        flex: 1,
        textAlign: 'left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        opacity: '1 !important',
    },
    ButtonSelectorLabelPlaceholder: {
        fontWeight: 400,
        color: defaultPalette.lightGrey.darker,
    },
    ButtonSelectorPaper: {
        padding: '0 .5rem .5rem',
        borderRadius: '0 0 .5rem.5rem',
        border: 'none',
        zIndex: 100,
        boxShadow: '0px 12px 54px 0px rgba(119, 122, 130, 0.25), 0px 12px 24px 0px rgba(119, 122, 130, 0.25)',
        '& .MuiList-root': {
            padding: 0,
        },
    },
    ButtonSelectorPaperInner: {
        background: defaultPalette.lightGrey.ultraLight,
        borderRadius: '0 0 .25rem .25rem',
    },
    ButtonSelectorMenuItem: {
        fontWeight: 600,
        padding: '.5rem 1rem',
    },
    ButtonSelectorMenuItemSelected: {
        color: defaultPalette.typography.light,
    },
    ButtonSelectorContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexDirection: 'column',
        gap: '.5rem',
    },
    ButtonSelectorMessagesContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-end',
        flexDirection: 'column',
    },
    ButtonSelectorMessagesWarning: {
        color: defaultPalette.orangeWarning.main,
    },
}))
